import axios from "axios";
import {
  ASSIGN_ADDENDUM,
  LIST_ALL_CONTRACTS_FOR_ADDENDUM,
  UNASSIGN_ADDENDUM,
} from "@/utils/constants/constants.js";

export default {
  methods: {
    async fetch_contracts(addendum_id) {
      this.select_template_id = addendum_id;
      const matched_template = this.manage_template.find(template => template.id === addendum_id);
      if (matched_template) {
        this.selected_template = { ...matched_template };
      }

      try {
        const response = await axios.get(LIST_ALL_CONTRACTS_FOR_ADDENDUM, {
          params: { addendum_entity_type_id: addendum_id },
          headers: this.headers,
        });

        if (response.data?.status !== "success") {
          this.show_error(response.data?.message || "Failed to fetch contracts");
          return;
        }

        const contracts = (response.data.data || []).map(contract => ({
          id: contract.contract_entity_type_id,
          template_name: contract.contract_name,
          addendum_entity_type_id: addendum_id,
          is_assigned: contract.is_assigned,
          isLoading: false,
        }));

        Reflect.set(this.contracts_by_template, addendum_id, contracts);
        this.table_safe_contracts = contracts;
      } catch (error) {
        this.show_error("Error fetching contracts: " + (error.response?.data?.message || error.message));
      }
    },
    async assign_contract(row) {
      row.is_loading = true;
      try {
        await axios.post(
          ASSIGN_ADDENDUM,
          { contract_entity_type_id: row.id, addendum_entity_type_id: this.select_template_id },
          { headers: this.headers }
        );

        this.show_success(`Assigned ${row.template_name} successfully.`);
        await this.fetch_contracts(this.select_template_id);
      } catch (error) {
        row.is_assigned = false;
        this.show_error("Assignment failed: " + (error.response?.data?.message || error.message));
      } finally {
        row.is_loading = false;
      }
    },
    async unassign_contract(row) {
      row.is_loading = true;
      try {
        await axios.post(
          UNASSIGN_ADDENDUM,
          { contract_entity_type_id: row.id, addendum_entity_type_id: this.select_template_id },
          { headers: this.headers }
        );

        this.show_success(`Unassigned ${row.template_name} successfully.`);
        await this.fetch_contracts(this.select_template_id);
      } catch (error) {
        row.is_assigned = true;
        this.show_error("Unassignment failed: " + (error.response?.data?.message || error.message));
      } finally {
        row.is_loading = false;
      }
    },
    open_assign_contracts_modal(template) {
      this.modal_template = { ...template };
      this.table_safe_contracts = this.contracts_by_template[template.id] || [];
      this.fetch_contracts(template.id);
    },
  },
};
